import { render, staticRenderFns } from "./research-institute.vue?vue&type=template&id=4a5c2422"
import script from "./research-institute.vue?vue&type=script&lang=ts"
export * from "./research-institute.vue?vue&type=script&lang=ts"
import style0 from "./research-institute.vue?vue&type=style&index=0&id=4a5c2422&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports